import jQuery from 'expose-loader?$!expose-loader?jQuery!../../../libs/jquery/dist/jquery';

import "script-loader!../../../libs/jquery-validation/dist/jquery.validate.js"
import "script-loader!../../../libs/owl.carousel/dist/owl.carousel.js"
import "script-loader!../../../libs/pickadate/lib/compressed/picker.js"
import "script-loader!../../../libs/pickadate/lib/compressed/picker.date.js"
import "script-loader!../../../libs/doubletaptogo/jquery.doubletaptogo.js"
import "script-loader!../../../libs/magnific-popup/dist/jquery.magnific-popup.js"
import "script-loader!../../../libs/waypoints/lib/jquery.waypoints.js"
import "script-loader!../../../libs/jquery.counterup/jquery.counterup.js"

export default jQuery



// WEBPACK FOOTER //
// ./public/assets/js/src/vendor/jquery.js